module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "Router02",
	"sourceName": "contracts/levels/DiscoLP.sol",
	"abi": [
		{
			"inputs": [],
			"name": "WETH",
			"outputs": [
				{
					"internalType": "address",
					"name": "_token",
					"type": "address"
				}
			],
			"stateMutability": "pure",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_tokenA",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "_tokenB",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_amountADesired",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amountBDesired",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amountAMin",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amountBMin",
					"type": "uint256"
				},
				{
					"internalType": "address",
					"name": "_to",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_deadline",
					"type": "uint256"
				}
			],
			"name": "addLiquidity",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "_amountA",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amountB",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_liquidity",
					"type": "uint256"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_amountIn",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_reserveIn",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_reserveOut",
					"type": "uint256"
				}
			],
			"name": "getAmountOut",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "_amountOut",
					"type": "uint256"
				}
			],
			"stateMutability": "pure",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_tokenA",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "_tokenB",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_liquidity",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amountAMin",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amountBMin",
					"type": "uint256"
				},
				{
					"internalType": "address",
					"name": "_to",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_deadline",
					"type": "uint256"
				}
			],
			"name": "removeLiquidity",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "_amountA",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amountB",
					"type": "uint256"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_amountOut",
					"type": "uint256"
				},
				{
					"internalType": "address[]",
					"name": "_path",
					"type": "address[]"
				},
				{
					"internalType": "address",
					"name": "_to",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_deadline",
					"type": "uint256"
				}
			],
			"name": "swapETHForExactTokens",
			"outputs": [
				{
					"internalType": "uint256[]",
					"name": "_amounts",
					"type": "uint256[]"
				}
			],
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_amountIn",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amountOutMin",
					"type": "uint256"
				},
				{
					"internalType": "address[]",
					"name": "_path",
					"type": "address[]"
				},
				{
					"internalType": "address",
					"name": "_to",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_deadline",
					"type": "uint256"
				}
			],
			"name": "swapExactTokensForTokens",
			"outputs": [
				{
					"internalType": "uint256[]",
					"name": "_amounts",
					"type": "uint256[]"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "0x",
	"deployedBytecode": "0x",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/DiscoLP.sol/Router02.json
// module id = 1539
// module chunks = 0